import { render, staticRenderFns } from "./InsSlideMenu.vue?vue&type=template&id=3b0584f6&scoped=true"
import script from "./InsSlideMenu.vue?vue&type=script&lang=ts"
export * from "./InsSlideMenu.vue?vue&type=script&lang=ts"
import style0 from "./InsSlideMenu.vue?vue&type=style&index=0&id=3b0584f6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0584f6",
  null
  
)

export default component.exports